import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function HighEvo() {
  const { name: routeName } = useParams();
  const displayName = routeName || "HighEvo";
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}api/data/snapArchetypes/${displayName}`);
        if (!res.ok) throw new Error("Failed to fetch archetype cards");
        const data = await res.json();
        setCards(data);
      } catch (err) {
        console.error("Error fetching archetype cards:", err);
        setError("Unable to load cards.");
      } finally {
        setLoading(false);
      }
    };
    fetchCards();
  }, [displayName]);

  if (loading) return <p style={{ textAlign: "center", color: "#ccc" }}>Loading {displayName} cards...</p>;
  if (error) return <p style={{ textAlign: "center", color: "red" }}>{error}</p>;

  return (
    <div className="app-wrapper">
      <h1 style={{ textAlign: "center", color: "rgb(197,176,55)" }}>{displayName} Archetype</h1>
      <div className="card-grid">
        {cards.map((card) => (
          <div key={card.id} className="card-snap">
            {card.cardhtml?.startsWith("http") && (
              <img
                src={card.cardhtml}
                alt={card.cardname}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  objectFit: "cover",
                }}
              />
            )}
            <p style={{ fontSize: "0.9rem", marginTop: "6px" }}>{card.carddesc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HighEvo;
